import React from 'react';
import Popover from '@/components/ui/Popover';
import { useMutation } from '@tanstack/react-query';
import Axios from 'axios';
import * as Routes from '@/modules/routes';
import QueryKeys from '@/utils/QueryKeys';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import { GlossaryTermModel, SlideObject } from '@/components/admin/SlideShow/types';
import { IImageModel } from '@/components/admin/SlideShow/stores/useSlideShowStore';

interface VocabTableImageProps {
  editModalManager: any;
  glossaryTermModel: GlossaryTermModel;
  hasImage: boolean;
  modalManager: any;
  setGlossaryTermModelId: (num: number) => void;
  setImageModelToEdit: (imageModel: IImageModel) => void;
  slideObject: SlideObject;
}

const VocabTableImage = ({
  editModalManager, glossaryTermModel, hasImage, modalManager, setGlossaryTermModelId, setImageModelToEdit, slideObject,
}: VocabTableImageProps) => {
  const updateSlideObject = useSlideShowContext(state => state.updateSlideObject);
  const isPresentMode = useSlideShowContext(state => state.isPresentMode);

  const { mutate: deleteGlossaryTermModel } = useMutation({
    mutationFn: () => Axios.delete(Routes.plato_api_image_model_path(glossaryTermModel.image_model?.id)),
    mutationKey: [QueryKeys.GlossaryTerms, QueryKeys.Mutations.Delete, glossaryTermModel.image_model?.id],
    onError: (err) => {
      // eslint-disable-next-line no-console
      console.error(err);
    },
    onSuccess: () => {
      updateSlideObject({ ...slideObject });
    },
  });

  const editImage = () => {
    setImageModelToEdit(glossaryTermModel.image_model);
    setGlossaryTermModelId(glossaryTermModel.id);
    editModalManager.open();
  };

  const btnStyles = 'tw-text-3xl tw-border-none tw-bg-inherit tw-cursor-pointer tw-outline-none focus:tw-outline-none';

  return (
    <div
      className="tw-flex tw-flex-col tw-border-solid tw-border-l-[1px] tw-border-r-[1px] tw-basis-1/4
                 tw-items-center tw-justify-center"
    >
      {(hasImage || isPresentMode) ? (
        <Popover>
          <Popover.Trigger
            className="tw-flex tw-items-center tw-justify-center tw-bg-none tw-border-none tw-bg-inherit tw-p-0"
            disabled={isPresentMode}
          >
            {hasImage && (
              <img
                alt={`${glossaryTermModel.id}`}
                className="tw-w-full tw-h-full tw-object-contain"
                id={`glossary-term-model-${glossaryTermModel.id}-image`}
                src={glossaryTermModel.image_en_url}
              />
            )}
          </Popover.Trigger>
          <Popover.Content className="tw-flex tw-w-20 tw-justify-between tw-p-2">
            <button
              aria-label="Delete Image"
              className={btnStyles}
              type="button"
              onClick={() => deleteGlossaryTermModel()}
            >
              <i className="fa fa-trash-o" />
            </button>
            <button
              aria-label="Edit Image"
              className={btnStyles}
              type="button"
              onClick={() => editImage()}
            >
              <i className="fa fa-pencil-square-o" />
            </button>
          </Popover.Content>
        </Popover>
      ) : (
        <button
          className="btn btn--purple btn--sm"
          type="button"
          onClick={() => {
            setGlossaryTermModelId(glossaryTermModel.id);
            modalManager.open();
          }}
        >
          Add Image
        </button>
      )}
    </div>
  );
};

export default VocabTableImage;
